import OldProofTaxRegime from "./oldProofTaxRegime";
export default OldProofTaxRegime;